import React from 'react'
import PropTypes from 'prop-types'

import { Button, Icon, PreorderPopup } from '../../..'
import { useVisibility } from '../../../../utils'
import { useSnippetContent, useTranslation } from '../../../../utils/providers'

function PreorderButton({ productData }) {
  const { t } = useTranslation()
  const { openPopupButtonLabel } = useSnippetContent('preorder_popup') || {}

  const { isVisible, show, hide } = useVisibility()

  return (
    <>
      <Button
        variant="secondary"
        className="product-action-bubble"
        title={openPopupButtonLabel || t('PRODUCT_TILE_PREORDER')}
        onClick={show}
        data-testid="btn-preorder"
      >
        <Icon symbol="cf-envelop-o" className="font-size-l" />
      </Button>
      {isVisible && (
        <PreorderPopup closeAction={hide} productData={productData} />
      )}
    </>
  )
}

PreorderButton.propTypes = {
  productData: PropTypes.object.isRequired,
}

export default PreorderButton
